import { hideValidationMessage } from "../../form-validation-message";
import { debounceApiWithDelay } from "./debounce-api";
import { triggerAddressApi } from "./rmo-address-api";

export const addressAttachToLocationFields = (parentEl) => {
  let addressLookupEls = parentEl.querySelectorAll(".address-lookup");
  let isRMOPage =  window.location.href.indexOf("rmo-form") !== -1 ?  true :false
  
  const setAdressParameters = (dropdown, data, find) => {
    const dropdownParent = dropdown?.closest(".wuds-dropdown");
    const spancountryValueEl = dropdownParent?.querySelector(
      ".b-flag-select__value"
    );
    const inputEl = dropdownParent?.querySelector(
      ".b-flag-select__search-field"
    );
    Array.from(dropdown.children).forEach((li) => {
      const code = li.getAttribute("data-" + find);
      if (code == data) {
        spancountryValueEl.innerText = li.innerText;
        if (inputEl) {
          inputEl.setAttribute("data-" + find, data);
          inputEl.setAttribute("value", li.innerText);
          inputEl.value = li.innerText;
        }
      }
    });
  };

  const debouncedFunction = async (
    addressLookupUl,
    addressLookupEl,
    AkCountry
  ) => {
    const dataAddressApi = await triggerAddressApi(AkCountry, addressLookupEl);
    const fragment = document.createDocumentFragment();
    addressLookupUl.innerHTML = "";
    for (let data of (dataAddressApi.address || [])) {
      addLiTounorderedList(
        data.rawAddress.replace(/"/g, ""),
        JSON.stringify(data),
        fragment
      );
    }
    addressLookupUl.append(fragment);
    addressLookupUl.classList.remove("d-none");
    addressLookupUl.classList.add("d-block");
    const lis = addressLookupUl.querySelectorAll("li");
    Array.from(lis).forEach((li) => {
      li.addEventListener("click", (e) => {
        e.preventDefault();
        if (isRMOPage) {

        const rowEL = addressLookupEl.closest(".row");
        const dataValue = JSON.parse(li.getAttribute("data-value"));
        const address1 = rowEL.querySelector('[class*="address-lookup-addr1"]');
        const cityEl = rowEL.querySelector('[class*="address-lookup-city"]');
        const postalCodeEl = dataValue["postalCode"]?.rowEL.querySelector(
          '[class*="address-lookup-zip"]'
        );
        if (address1) {
          address1.setAttribute("value", dataValue["addressLine1"]);
          address1.value = dataValue["addressLine1"];
          hideValidationMessage(address1);
        }
        // rowEL.querySelector('[class*="address-lookup-addr2"]')?.setAttribute('value',dataValue["addressLine2"])
        if (cityEl) {
          cityEl.setAttribute("value", dataValue["city"]);
          cityEl.value = dataValue["city"];
          hideValidationMessage(cityEl);
        }

        if (postalCodeEl) {
          postalCodeEl?.setAttribute("value", dataValue["postalCode"]);
          postalCodeEl.value = dataValue["postalCode"];
          hideValidationMessage(postalCodeEl);
        }
    
          const countryDropdownEl = rowEL.querySelector(".country-dropdown-ul");
          const countryCode = dataValue["countryCode"]
            ?.substring(0, 2)
            ?.toLowerCase();
          setAdressParameters(countryDropdownEl, countryCode, "slug");
          hideValidationMessage(countryDropdownEl);

        const stateDropdownEl = rowEL.querySelector(
          '[id^="state-dropdown-ul"]'
        );

          setAdressParameters(stateDropdownEl, dataValue["stateCode"], "value");
          hideValidationMessage(stateDropdownEl);
        }
        addressLookupUl.innerHTML = "";
      });
    });
  };


  Array.from(addressLookupEls).forEach((addressLookupEl) => {
    const addressLookupUl = addressLookupEl.parentElement.querySelector(
      "ul.address-lookup-ul"
    );
    let timer = {data: null};
    addressLookupEl.addEventListener("keydown", async (e) => {
      let AkCountry
      const nearestParentEl = addressLookupEl.closest(".repeater-mo-individual") ||  addressLookupEl.closest(".repeater-contact-info")
      if (isRMOPage) {
        const countryEL = nearestParentEl.querySelector("[id^=country-dropdown]")
        AkCountry = countryEL?.getAttribute("data-slug") || getAkCountryRMO();
      }
      const debouncedApi = await debounceApiWithDelay(debouncedFunction, 200, timer);
      await debouncedApi(addressLookupUl, addressLookupEl, AkCountry);
    });

    addressLookupEl.addEventListener("blur", () => {
      addressLookupUl.setAttribute('style', 'border-bottom: 0px')
      setTimeout(() => {
        addressLookupUl.classList.add("d-none");
        addressLookupUl.classList.remove("d-block");
        addressLookupUl.removeAttribute("style");
      }, 400);
    });
  });
};
